import axios from "axios"
import { env } from '../constants'


/* The token of the administrator goes with every call */
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })


/* LIST — what clients write to the Whatsapp number */
export const list = data => {
    const uri = `${env.startpoint}/admin/inbox/list`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* STATUS — dealt with or back to the new ones: { ids | waID, status } */
export const status = data => {
    const uri = `${env.startpoint}/admin/inbox/status`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* MEDIA — the file of a message, straight from Meta */
export const media = data => {
    const uri = `${env.startpoint}/admin/inbox/media`
    return axios.post(uri, data, { ...auth(), responseType: "blob" }).then(response => response).catch(error => error.response)
}
